import { adminServerInstance, appMainServerInstance } from "../axios/instances";
import _ from 'lodash';
import { 
    GET_SORTING_HISTORY,
    GET_SORTING_HISTORY_SUCCESS,
    GET_SORTING_HISTORY_FAIL,
    GET_SORTING_HISTORY_LIST,
    GET_SORTING_HISTORY_LIST_SUCCESS,
    GET_SORTING_HISTORY_LIST_FAIL,
    SAVE_SORTING_HISTORY,
    SAVE_SORTING_HISTORY_SUCCESS,
    SAVE_SORTING_HISTORY_FAIL,
    APPLY_CONFIGURATION,
    APPLY_CONFIGURATION_SUCCESS,
    APPLY_CONFIGURATION_FAIL,
    GET_WAREHOUSE_TOTAL_SLOTS,
    GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS,
    GET_WAREHOUSE_TOTAL_SLOTS_FAIL,
    GET_BATCH_ALL,
    GET_BATCH_ALL_SUCCESS,
    GET_BATCH_ALL_FAIL,
    GET_BATCH_ORDER_ALL,
    GET_BATCH_ORDER_ALL_SUCCESS,
    GET_BATCH_ORDER_ALL_FAIL,
    GET_BATCH_INFO_ALL,
    GET_BATCH_INFO_ALL_SUCCESS,
    GET_BATCH_INFO_ALL_FAIL,
    GET_DRIVER_ORDER_COUNT_ALL,
    GET_DRIVER_ORDER_COUNT_ALL_SUCCESS,
    GET_DRIVER_ORDER_COUNT_ALL_FAIL,
    GET_DISTRICT_ALL,
    GET_DISTRICT_ALL_SUCCESS,
    GET_DISTRICT_ALL_FAIL,
    GET_STAFF_LIST_ALL,
    GET_STAFF_LIST_ALL_SUCCESS,
    GET_STAFF_LIST_ALL_FAIL,
    GET_BLIND_SCAN_BATCH,
    GET_BLIND_SCAN_BATCH_SUCCESS,
    GET_BLIND_SCAN_BATCH_FAIL,
    SET_BLIND_BATCH,
    SET_BLIND_BATCH_SUCCESS,
    SET_BLIND_BATCH_FAIL,
    SET_SCAN_MODE,
    SET_SCAN_MODE_SUCCESS,
    SET_SCAN_MODE_FAIL,
    GET_MACHINE_CONFIG,
    GET_MACHINE_CONFIG_SUCCESS,
    GET_MACHINE_CONFIG_FAIL,
    SET_SCAN_BATCH_LIST,
    SET_SCAN_BATCH_LIST_SUCCESS,
    SET_SCAN_BATCH_LIST_FAIL,
    CREATE_ZONE_SLOT_MAPPING,
    CREATE_ZONE_SLOT_MAPPING_SUCCESS,
    CREATE_ZONE_SLOT_MAPPING_FAIL,
    GET_ZONE_SLOT_MAPPING,
    GET_ZONE_SLOT_MAPPING_SUCCESS,
    GET_ZONE_SLOT_MAPPING_FAIL,
    EDIT_ZONE_SLOT_MAPPING,
    EDIT_ZONE_SLOT_MAPPING_SUCCESS,
    EDIT_ZONE_SLOT_MAPPING_FAIL,
    GET_PATTERN_ID_TYPE,
    GET_PATTERN_ID_TYPE_SUCCESS,
    GET_PATTERN_ID_TYPE_FAIL,
    GET_SORT_MANAGEMENT_LIST,
    GET_SORT_MANAGEMENT_LIST_SUCCESS,
    GET_SORT_MANAGEMENT_LIST_FAIL,
    EDIT_SORTING_MANAGEMENT,
    EDIT_SORTING_MANAGEMENT_SUCCESS,
    EDIT_SORTING_MANAGEMENT_FAIL,
    GET_ALL_MACHINE_CODES,
    GET_ALL_MACHINE_CODES_SUCCESS,
    GET_ALL_MACHINE_CODES_FAIL,
    REMOVE_DISPATCH_HISTORY,
    REMOVE_DISPATCH_HISTORY_SUCCESS,
    REMOVE_DISPATCH_HISTORY_FAIL,
    REMOVE_SORTING_HISTORY,
    REMOVE_SORTING_HISTORY_SUCCESS,
    REMOVE_SORTING_HISTORY_FAIL,
    DELETE_ZONE_SLOT,
    DELETE_ZONE_SLOT_SUCCESS,
    DELETE_ZONE_SLOT_FAIL
} from './types';

export function removedispatchhistory(id) {
    return function (dispatch) {
        dispatch({ type: REMOVE_DISPATCH_HISTORY })
        return adminServerInstance.post(`/map/removedispatchhistory`,
            {
                id: id
            }
        )
            .then(({ data }) => {
                dispatch({
                    type: REMOVE_DISPATCH_HISTORY_SUCCESS,
                    payload: data,
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: REMOVE_DISPATCH_HISTORY_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function removesortinghistorybyid(id) {
    return function (dispatch) {
        dispatch({ type: REMOVE_SORTING_HISTORY })
        return adminServerInstance.post(`/sortmachine/removesortinghistorybyid`,
            {
                id: id
            }
        )
            .then(({ data }) => {
                dispatch({
                    type: REMOVE_SORTING_HISTORY_SUCCESS,
                    payload: data,
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: REMOVE_SORTING_HISTORY_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.mapping_ids - mapping_id's
 */
export function deleteZoneSlot(params){
    return function(dispatch){
        dispatch({type: DELETE_ZONE_SLOT})
        return appMainServerInstance.post(`/sortmachine/deletezontslotmapping`, params)
        .then(({data}) => {
            dispatch({
                type: DELETE_ZONE_SLOT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: DELETE_ZONE_SLOT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getAllMachineCodes(){
    return function(dispatch){
        dispatch({type: GET_ALL_MACHINE_CODES})
        return appMainServerInstance.get(`/sortmachine/getallmachinecodes`)
        .then(({data}) => {
            dispatch({
                type: GET_ALL_MACHINE_CODES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: GET_ALL_MACHINE_CODES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.management_id - For ADD, no management_id needed
 * @param {string} params.machine_code - Machine code
 * @param {string} params.target_warehouse - Target warehouse id
 * @param {string} params.is_external - 0/1
 * @param {string} params.external_need_sorting - 0/1
 * @param {string} params.external_owner - External owner id
 */
export function editSortingManagement(params){
    return function(dispatch){
        dispatch({type: EDIT_SORTING_MANAGEMENT})
        return appMainServerInstance.post(`/sortmachine/editsortingmanagement`, params)
        .then(({data}) => {
            dispatch({
                type: EDIT_SORTING_MANAGEMENT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: EDIT_SORTING_MANAGEMENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.machine_code - Machine code, empty => all
 */
export function getSortManagementList(params){
    return function(dispatch){
        dispatch({type: GET_SORT_MANAGEMENT_LIST})
        return appMainServerInstance.get(`/sortmachine/getsortmanagementlist`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_SORT_MANAGEMENT_LIST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: GET_SORT_MANAGEMENT_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getPatternIdType(){
    return function(dispatch){
        dispatch({type: GET_PATTERN_ID_TYPE})
        return adminServerInstance.get(`/sortmachine/getallpatternid`)
            .then(({data}) => {
                dispatch({
                    type: GET_PATTERN_ID_TYPE_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: GET_PATTERN_ID_TYPE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getSortingHistory(id){
    return function(dispatch){
        dispatch({type: GET_SORTING_HISTORY})
        return adminServerInstance.get(`/sortmachine/getsortinghistory?id=${id}`)
            .then(({data}) => {
                dispatch({
                    type: GET_SORTING_HISTORY_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: GET_SORTING_HISTORY_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getSortingHistoryList(warehouse){
    return function(dispatch){
        dispatch({type: GET_SORTING_HISTORY_LIST})
        return adminServerInstance.get(`/sortmachine/getsortinghistorylist`,{
            params: {
                warehouse: warehouse,
                page: 1,
                offset: 10000
                //offset -  how many items per page
            }
        })
            .then(({data}) => {
                dispatch({
                    type: GET_SORTING_HISTORY_LIST_SUCCESS,
                    payload: data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_SORTING_HISTORY_LIST_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function saveSortingHistory(warehouse, owner, name, slot_configuration, id){
    return function(dispatch){
        dispatch({type: SAVE_SORTING_HISTORY})
        return adminServerInstance.post(`/sortmachine/savesortinghistory`,
        {
            warehouse: warehouse,
            owner: owner,
            name: name,
            slot_configuration: slot_configuration,
            id: id
        })
        .then(({data}) => {
            dispatch({
                type: SAVE_SORTING_HISTORY_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: SAVE_SORTING_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function applyConfiguration(batchlist, slot_configuration){
    return function(dispatch){
        dispatch({type: APPLY_CONFIGURATION})
        return adminServerInstance.post(`/sortmachine/applyconfiguration`, {
            batchlist: batchlist,
            slot_configuration: slot_configuration
        })
        .then(({data}) => {
            dispatch({
                type: APPLY_CONFIGURATION_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: APPLY_CONFIGURATION_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getWarehouseTotalSlots(warehouse){
    return function(dispatch){
        dispatch({type: GET_WAREHOUSE_TOTAL_SLOTS})
        return adminServerInstance.get(`/sortmachine/getwarehousetotalslots?warehouse=${warehouse}`)
            .then(({data}) => {
                dispatch({
                    type: GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS,
                    payload: data.data.total_slots
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: GET_WAREHOUSE_TOTAL_SLOTS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getBatchNumber(area = 1, timestamp) {
    return function(dispatch) {
        dispatch({type: GET_BATCH_ALL})
        return adminServerInstance.get(`/map/getbatchlist`, {
                params: {
                    branch: area,
                    start_time: timestamp
                }
            }).then(({data}) => {
                dispatch({
                    type: GET_BATCH_ALL_SUCCESS,
                    payload: data.data
                })
            }).catch(error => {
                dispatch({
                    type: GET_BATCH_ALL_FAIL,
                    payload: error
                })
            });
    }
}

export function getBatchOrderArea(batches) {
    return function(dispatch){
        dispatch({type: GET_BATCH_ORDER_ALL})
        return adminServerInstance.get(`/map/getbatchorders`, {
            params: {
                batch_list: batches.toString()
            }
            }).then(({data}) => {
                dispatch({
                    type: GET_BATCH_ORDER_ALL_SUCCESS,
                    payload: data
                })
            }).catch(error => {
                dispatch({
                    type: GET_BATCH_ORDER_ALL_FAIL,
                    payload: error
                })
            })
    }
}

export function getBatchInfo(districtId, batchIds){
    return function(dispatch){
        dispatch({type: GET_BATCH_INFO_ALL})
        return adminServerInstance.get('map/getordersnuminbatchlist', {
            params: {
                branch: districtId,
                batch_list: batchIds.toString()
            }
        }).then(({data}) => {
            dispatch({
                type: GET_BATCH_INFO_ALL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type: GET_BATCH_INFO_ALL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getDriverOrderCount(districtId = 1, batchIds=[]){
    return function(dispatch){
        dispatch({type: GET_DRIVER_ORDER_COUNT_ALL})
        return adminServerInstance.get('/map/getdriverordercountmerged', {
            params: {
                branch: districtId,
                batch_list: batchIds.toString(),
                hide_associated: 0
            }
            }).then(({data}) => {
                dispatch({
                    type: GET_DRIVER_ORDER_COUNT_ALL_SUCCESS,
                    payload: data.data
                })
            }).catch(error => {
                dispatch({
                    type: GET_DRIVER_ORDER_COUNT_ALL_FAIL,
                    payload: error
                })
            })
    }
}

export function getDistricts(){
    return function(dispatch){
        dispatch({type: GET_DISTRICT_ALL})
        return adminServerInstance.get(`/map/getdistricts`)
            .then(({data}) => {
                dispatch({
                    type: GET_DISTRICT_ALL_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_DISTRICT_ALL_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getStaffList(area = 1, isHired = 0, patternId = 0) {
    return function(dispatch) {
        dispatch({type: GET_STAFF_LIST_ALL})
        return adminServerInstance.get('/sortmachine/getalldrivers', {
                params: {
                    branch: area,
                    is_hired: isHired,
                    page: 1,
                    size: 100000,
                    pattern_id: patternId
                }
            }).then(({data}) => {
                dispatch({
                    type: GET_STAFF_LIST_ALL_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_STAFF_LIST_ALL_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getBlindScanBatch(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_BLIND_SCAN_BATCH})
        return adminServerInstance.get(`/cargo/getblindscanbatch?warehouse=${warehouse}`)
        .then(({data}) => {
                dispatch({
                    type: GET_BLIND_SCAN_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_BLIND_SCAN_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}


export function setBlindBatch(warehouse, batch) {
    return function(dispatch) {
        dispatch({type: SET_BLIND_BATCH})
        return adminServerInstance.post(`/cargo/setblindbatch`, {
            warehouse: warehouse,
            blind_scan_batch: batch
        })
        .then(({data}) => {
                dispatch({
                    type: SET_BLIND_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: SET_BLIND_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse - Warehouse ID
 * @param {string} params.machine_code - Machine code
 * @param {string} params.mode - mode
 * @param {string} params.target_state - Target state
 * @param {string} params.smart_sorting_action - 1=>machine_code===120
 * @param {string} params.smart_action_name - 1=>SORTING_ZONE 2=>SMART_ACTION_SORTING_ROUTE
 */
export function setScanMode(params) {
    return function(dispatch) {
        dispatch({type: SET_SCAN_MODE})
        return appMainServerInstance.post(`/sortmachine/setscanmode`, params)
        .then(({data}) => {
                dispatch({
                    type: SET_SCAN_MODE_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: SET_SCAN_MODE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getMachineConfig(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_MACHINE_CONFIG})
        return appMainServerInstance.get(`/sortmachine/getmachineconfig?warehouse=${warehouse}`)
        .then(({data}) => {
                dispatch({
                    type: GET_MACHINE_CONFIG_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_MACHINE_CONFIG_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function setScanBatchList(warehouse, batchList) {
    return function(dispatch) {
        dispatch({type: SET_SCAN_BATCH_LIST})
        return appMainServerInstance.post(`/sortmachine/setscanbatchlist`, {
            warehouse: warehouse,
            batch_list: batchList
        })
        .then(({data}) => {
                dispatch({
                    type: SET_SCAN_BATCH_LIST_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: SET_SCAN_BATCH_LIST_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function createZoneSlotMapping(warehouse, zone, gridCode) {
    return function(dispatch) {
        dispatch({type: CREATE_ZONE_SLOT_MAPPING})
        return appMainServerInstance.post(`/sortmachine/createzoneslotmapping`, {
            warehouse: warehouse,
            zone: zone,
            grid_codes: gridCode
        })
        .then(({data}) => {
                dispatch({
                    type: CREATE_ZONE_SLOT_MAPPING_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: CREATE_ZONE_SLOT_MAPPING_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getZoneSlotMapping(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_ZONE_SLOT_MAPPING})
        return appMainServerInstance.get(`/sortmachine/getzoneslotmapping?warehouse=${warehouse}`)
        .then(({data}) => {
                dispatch({
                    type: GET_ZONE_SLOT_MAPPING_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_ZONE_SLOT_MAPPING_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function editZoneSlotMapping(warehouse, zoneslots) {
    return function(dispatch) {
        dispatch({type: EDIT_ZONE_SLOT_MAPPING})
        return appMainServerInstance.post(`/sortmachine/editzoneslotmapping`, {
            warehouse: warehouse,
            zone_slots: zoneslots
        })
        .then(({data}) => {
                dispatch({
                    type: EDIT_ZONE_SLOT_MAPPING_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: EDIT_ZONE_SLOT_MAPPING_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}
